// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"11375d00","488":"ae9a6a8d"}[chunkId] + ".chunk.js";
};